// MobiFin Brand Theme Configuration
export const mobifinTheme = {
  // Brand Colors
  colors: {
    primary: {
      blue: '#0066CC',      // MobiFin Blue
      orange: '#FF6600',    // MobiFin Orange
    },
    secondary: {
      darkBlue: '#004499',
      lightBlue: '#3399FF',
      darkOrange: '#CC5200',
      lightOrange: '#FF8833',
    },
    neutral: {
      white: '#FFFFFF',
      offWhite: '#F8F9FA',
      lightGray: '#E9ECEF',
      gray: '#6C757D',
      darkGray: '#343A40',
      black: '#212529',
    },
    status: {
      success: '#28A745',
      warning: '#FFC107',
      error: '#DC3545',
      info: '#17A2B8',
    }
  },
  
  // Typography
  typography: {
    fontFamily: {
      primary: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      monospace: '"Courier New", Courier, monospace',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
    }
  },
  
  // Spacing
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
  },
  
  // Border Radius
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px',
  },
  
  // Shadows
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  
  // Component Styles
  components: {
    button: {
      primary: 'bg-[#0066CC] hover:bg-[#004499] text-white',
      secondary: 'bg-[#FF6600] hover:bg-[#CC5200] text-white',
      outline: 'border-2 border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white',
    },
    header: {
      background: 'bg-white border-b border-gray-200',
      height: '64px',
    },
    card: {
      background: 'bg-white rounded-lg shadow-md',
      padding: 'p-4',
    }
  }
}

// Tailwind class helpers
export const mobifinClasses = {
  // Buttons
  primaryButton: 'px-4 py-2 bg-[#0066CC] hover:bg-[#004499] text-white rounded-md transition-colors',
  secondaryButton: 'px-4 py-2 bg-[#FF6600] hover:bg-[#CC5200] text-white rounded-md transition-colors',
  outlineButton: 'px-4 py-2 border-2 border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white rounded-md transition-colors',
  
  // Text
  primaryText: 'text-[#0066CC]',
  secondaryText: 'text-[#FF6600]',
  
  // Backgrounds
  primaryBg: 'bg-[#0066CC]',
  secondaryBg: 'bg-[#FF6600]',
  
  // Headers
  pageHeader: 'bg-white border-b border-gray-200 shadow-sm',
  
  // Cards
  card: 'bg-white rounded-lg shadow-md p-4',
}

export default mobifinTheme